/** Figma `StatCard` 세트(Components, 2030:2524)의 축. `value` 축은 코드에서 `valueSize`(fe-rules 1절) */
export const STAT_CARD_SURFACES = ['white', 'mint'] as const;
export type StatCardSurface = (typeof STAT_CARD_SURFACES)[number];

export const STAT_CARD_LAYOUTS = ['vertical', 'horizontal'] as const;
export type StatCardLayout = (typeof STAT_CARD_LAYOUTS)[number];

/**
 * 값 글자 색 — default = 검정(fg-default), primary = 레거시 포트폴리오 IRR · Multiple 카드의 Primary(#00ada0).
 * primary 는 글자 토큰 fg-primary(700) 대신 fg-metric-primary(primary-500) — 배지처럼 구 서비스 색 예외(DD-78)
 */
export const STAT_CARD_TONES = ['default', 'primary'] as const;
export type StatCardTone = (typeof STAT_CARD_TONES)[number];

export const VALUE_TONE_CLASS: Record<StatCardTone, string> = {
  default: 'text-fg-default',
  primary: 'text-fg-metric-primary',
};

/** md = 18(`title`), lg = 20(`heading-3`) */
export const STAT_CARD_VALUE_SIZES = ['md', 'lg'] as const;
export type StatCardValueSize = (typeof STAT_CARD_VALUE_SIZES)[number];

/** 흰 면 = 모서리 12 + shadow-card, 민트 면 = 모서리 8 · 그림자 없음 */
export const SURFACE_CLASS: Record<StatCardSurface, string> = {
  white: 'rounded-2xl bg-bg-surface shadow-card',
  mint: 'rounded-lg bg-bg-manager',
};

/**
 * 왼쪽 묶음: 세로 = 제목 → 값 → 보조 글자, 가로 = 제목 왼쪽 · 값 오른쪽 한 줄.
 * 가로는 Figma `Left` 높이 50 고정(세로 md 와 같은 카드 높이 82) — 값 줄 26 + 위아래 12
 */
export const LAYOUT_CLASS: Record<StatCardLayout, string> = {
  vertical: 'flex-col items-start gap-2',
  horizontal: 'flex-row items-center justify-between gap-2 py-3',
};

export const VALUE_SIZE_CLASS: Record<StatCardValueSize, string> = {
  md: 'typo-title',
  lg: 'typo-heading-3',
};

/** 오른쪽 원형 아이콘 자리(지름 60 = `size.icon-circle`) */
export const STAT_CARD_ICON_CIRCLE_CLASS =
  'inline-flex size-(--size-icon-circle) shrink-0 items-center justify-center rounded-full bg-bg-secondary-subtle';
